<template lang="pug">
.menu
  v-toolbar(dark, color='primary', app, clipped-left)
    v-toolbar-title.white--text EC-Model
    v-spacer
    v-toolbar-item {{ userMail }}
    v-btn(flat, @click='logout') Logout
  v-navigation-drawer(dark, color="primary", app, clipped)
      v-list
        v-list-tile(v-for='item in items', :key='item.title', @click='$router.push({ name: item.link })', :class="{'active': $route.name === item.link}")
          v-list-tile-action(v-if="!item.isTitle")
            v-icon {{ item.icon }}
          v-list-tile-content
            v-list-tile-title(v-bind:class="{ 'font-weight-black': item.isTitle }") {{ item.title }}
</template>
<script>
import LocalDataUtil from '@/utils/LocalDataUtil'

export default {
  name: 'EmMenu',
  data () {
    return {
      userMail: '',
      items: [
        { title: 'ALL', isTitle: true }, // グループ名は, isTitle = true
        { title: 'Top', icon: 'dashboard', link: 'main' }, // 各メニューはicon, link
        { title: 'Contents', isTitle: true }, // グループ名は, isTitle = true
        { title: '商品管理', icon: 'shopping_basket', link: 'item' }, // 各メニューはicon, methodを追加する
        { title: 'バナー管理', icon: 'list', link: 'banner' },
        { title: 'カテゴリー管理', icon: 'category', link: 'category' },
        { title: '生産者', icon: 'person', link: 'producer' },
        { title: 'Push通知', icon: 'notification_important', link: 'push' },
        { title: 'User', isTitle: true },
        { title: '注文管理', icon: 'shopping_cart', link: 'order' },
        { title: 'Admin', isTitle: true },
        { title: '管理者管理', icon: 'account_box', link: 'admin' }
      ]
    }
  },
  computed: {
  },
  methods: {
    logout () {
      this.$store.dispatch('logout', {}).then(() => {
      })
    }
  },
  created () {
    // 全てのページで読み込むのでここでAuthを行う
    if (LocalDataUtil.checkAccessToken()) {
      this.userMail = localStorage.getItem('em_email')
    } else {
      this.logout()
    }
  }
}
</script>
<style lang="stylus" scoped>

.active
  background-color #535353

</style>
